import React from "react";
import PdiTabsComponent from "../components/PDI Witness/PdiTabsComponent";

function PdiWitness() {
    return (
        <div>
            <PdiTabsComponent />
        </div>
    );
}

export default PdiWitness;